export const Card = ({ children }) => {
  return <div className="Card">{children}</div>;
};
